export default __webpack_public_path__ + "static/media/project_redux.5fc73e9c.WebP";